import React, { useState, useEffect } from "react";
import ThumpsUp from "../../../assets/thumps-up2.svg";
import ReplyIcon from "../../../assets/reply2.svg";
import AddPost from "../modal/add-post";
import { AiOutlineLike, AiFillLike } from "react-icons/ai";
import { miniBookService } from "../../../services/miniBookService/miniBookService";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useSelector } from "react-redux";
import { communityService } from "../../../services/communityService/communityService";
import Swal from "sweetalert2";

const Replies = ({ discussion, handleAddPostData, isChild = false, getGeneralDiscussion }) => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [tempDiscussion, setTempDiscussion] = useState();
    const userData = useSelector((state) => state?.auth?.userData);
    const [showEditModal, setShowEditModal] = useState(false);

    useEffect(() => {
        setTempDiscussion(discussion);
    }, [discussion]);

    const handleAddPost = () => {
        setShowAddModal(true);
    };

    const handleEditPost = () => {
        setShowEditModal(true);
    };

    const closeAddPost = (data) => {
        setShowAddModal(false);
        handleReload(discussion.discussion.general_community_question_id, data);
    };

    const handleCloseEditPost = (data) => {
        setShowEditModal(false);
        handleReload(discussion.discussion.general_community_question_id, data);
    };

    const handleReload = (questionId, data) => {
        handleAddPostData(questionId, data);
    };

    const handleLike = () => {
        miniBookService.addLike(tempDiscussion?.discussion.id, false).then((res) => {
            handleAddPostData(tempDiscussion?.discussion.general_community_question_id, res);
        });
    };

    const renderAnswer = (answer) => {
        const linkRegex = /(https?:\/\/[^\s]+)/g;
        const parts = answer.split(linkRegex);
        return parts.map((part, index) => {
            if (part.match(linkRegex)) {
                return (
                    <a key={index} href={part} target="_blank" rel="noopener noreferrer" className="fw-bold">
                        {part}
                    </a>
                );
            } else {
                return <span key={index}>{part}</span>;
            }
        });
    };

    const handleDeleteConfirmation = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                handleDelete();
            }
        });
    };

    const handleDelete = () => {
        communityService
            .deleteGeneralDiscussion(tempDiscussion?.discussion.id)
            .then((res) => {
                if (res) {
                    Swal.fire("Deleted!", "Your post has been deleted.", "success");
                    getGeneralDiscussion();
                }
            })
            .catch((error) => {
                Swal.fire("Error!", "Failed to delete the post.", "error");
            });
    };

    return (
        <>
            <div className={isChild ? "mt-2 mb-2 child-container" : "reply-container mt-2 mb-2"}>
                <div className="comments-display">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-row">
                            <div className="d-flex flex-lg-row w-100 justify-space-between">
                                <div className="reply-text">
                                    {/* <div>{discussion.discussion.title}</div> */}
                                    <div>{renderAnswer(discussion.discussion.answer)}</div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex flex-column justify-content-end align-items-end gap-1">
                            <div className="cursor-pointer align-center d-flex" onClick={() => handleLike()}>
                                {/* <img src={ThumpsUp}></img> */}
                                {tempDiscussion?.discussion?.likes > 0 ? (
                                    <div style={{ fontSize: "12px", marginRight: "5px" }} className="wd-35">
                                        {tempDiscussion?.discussion?.likes + " " + (tempDiscussion?.discussion?.likes > 1 ? "Likes" : "Like")}
                                    </div>
                                ) : (
                                    ""
                                )}
                                {tempDiscussion?.discussion?.hasUserLiked ? (
                                    <>
                                        <AiFillLike />
                                    </>
                                ) : (
                                    <>
                                        <AiOutlineLike />
                                    </>
                                )}
                            </div>
                            {discussion?.discussion?.user_id == userData?.id && (
                                <div className="d-flex gap-1">
                                    <button className="border-0 p-0" style={{ background: "unset", color: "#bc9c6c" }} onClick={() => handleEditPost()}>
                                        <FaRegEdit fontSize={20} />
                                    </button>
                                    <button className="border-0 p-0" style={{ background: "unset", color: "rgba(139, 0, 50, 1)" }} onClick={handleDeleteConfirmation}>
                                        <MdDelete fontSize={24} />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="d-flex flex-row mt-2 mb-2 cursor-pointer" onClick={() => handleAddPost()}>
                        <img src={ReplyIcon}></img>

                        <span className="reply-t">Reply</span>
                    </div>
                    {tempDiscussion?.replies.length > 0 && (
                        <>
                            {tempDiscussion?.replies.map((reply, key) => {
                                return <Replies discussion={reply} key={key} isChild={true} handleAddPostData={handleAddPostData} getGeneralDiscussion={getGeneralDiscussion} />;
                            })}
                        </>
                    )}
                </div>
            </div>
            {showAddModal && (
                <AddPost
                    onClose={closeAddPost}
                    questionId={tempDiscussion?.discussion.general_community_question_id}
                    parentId={tempDiscussion?.discussion.id}
                    isReply={true}
                    getGeneralDiscussion={getGeneralDiscussion}
                />
            )}
            {showEditModal && (
                <AddPost
                    onClose={handleCloseEditPost}
                    questionId={tempDiscussion?.discussion.general_community_question_id}
                    parentId={tempDiscussion?.discussion.id}
                    isReply={true}
                    getGeneralDiscussion={getGeneralDiscussion}
                    isEdit={true}
                />
            )}
        </>
    );
};

export default Replies;
